import APIClient from '../../../common/APIClient';
import { displayError, SUCCESS_ALERT, toggleShowAlert } from '../commonActions';
import { SET_PROJECT } from '../projects/projectsActions'; 
import qs from 'qs';
import { Cache } from 'aws-amplify';

const SET_PROJECT_SCOPING = 'SET_PROJECT_SCOPING';
const SET_COSTING_TOTALS = 'SET_COSTING_TOTALS';
const RESET_COSTING_TOTALS = 'RESET_COSTING_TOTALS';
const SET_TASK_DISTRIBUTIONS = 'SET_TASK_DISTRIBUTIONS';
const UPDATE_PROJECT_PLATFORM_BAND = 'UPDATE_PROJECT_PLATFORM_BAND';
const SET_PROJECT_PLATFORMS_BANDS = 'SET_PROJECT_PLATFORMS_BANDS';
const SET_BLENDED_RATES = 'SET_BLENDED_RATES';
const ADD_BLENDED_RATES = 'ADD_BLENDED_RATES';
const RESET_BLENDED_RATES = 'RESET_BLENDED_RATES';
const RESET_TASK_DISTRIBUTION = 'RESET_TASK_DISTRIBUTION';
const ADD_ALL_PROJECT_SCOPING = 'ADD_ALL_PROJECT_SCOPING';

export const PROFIT_NET_OF_TAX_MULTIPLIER = 0.7;

const client = () => {
  var apiClient = new APIClient();
  return apiClient.make();
}

export const scopingData = (platformId) => {
  return [
    {band_group: "A", mandays: 0, manhours: 0, percentage: 0, platform_id: platformId}, 
    {band_group: "B", mandays: 0, manhours: 0, percentage: 0, platform_id: platformId}, 
    {band_group: "C", mandays: 0, manhours: 0, percentage: 0, platform_id: platformId}, 
    {band_group: "D", mandays: 0, manhours: 0, percentage: 0, platform_id: platformId}, 
    {band_group: "E", mandays: 0, manhours: 0, percentage: 0, platform_id: platformId}, 
    {band_group: "F", mandays: 0, manhours: 0, percentage: 0, platform_id: platformId}, 
    {band_group: "G", mandays: 0, manhours: 0, percentage: 0, platform_id: platformId}, 
  ];
}

export const fetchProjectScope = (filters = null, platforms = null, setInit = false) => {
  let params = {} 

  if (filters && Object.keys(filters).length) {
    filters.platform_id = platforms;
    Object.assign(params, { filters });
  }

  return(dispatch) => {
    client().get(
      'project-scoping/list', {
        params,
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        let projScoping = result.data;
        if (!projScoping.length) {
          projScoping = [];
          if (platforms && platforms.length) {
            platforms.forEach(platformId => {
              projScoping.push(...scopingData(platformId));
            })
          }
        }
        else {
          let platformsInScope = []; //platforms in existing scope
          projScoping.forEach(scope => {
            if (!platformsInScope.includes(scope.platform_id)) {
              platformsInScope.push(scope.platform_id);
            }
          })

          //there's a new platform added
          if (platforms.length > platformsInScope.length) {
            platforms.forEach(platformId => {
              if (!platformsInScope.includes(platformId)) {
                projScoping.push(...scopingData(platformId));
              }
            })
          }
        }

        dispatch({type: SET_PROJECT_SCOPING, projScoping});  
      }
    }).catch(error => {
      dispatch(displayError(error));
    })

    setTimeout(() => {
      dispatch(computeTotals());   
    }, 4000)
  }
}

/**
 * Fetches the scope or the budget for the children projects
 * @param {*} filters 
 * @param {*} platforms 
 * @returns dispatch
 */
export const fetchChildrenScopes = (filters = null, platforms = null) => {
  let params = {} 

  if (filters && Object.keys(filters).length) {
    params.filters = filters;
  }

  return (dispatch) => {
    client().get(
      'project-scoping/list', {
        params,
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        let projScoping = result.data;

        if (projScoping.length) {
          projScoping.forEach(scope => {
            dispatch({type: ADD_ALL_PROJECT_SCOPING, scope});  
          })
        }
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const setInitialScope = (platforms) => {
  return (dispatch) => {
    let projScoping = [];
    if (typeof(platforms) !== "undefined" && platforms) {
      platforms.length && platforms.forEach(platformId => {
        projScoping.push(...scopingData(platformId));
      })
    }

    dispatch({type: SET_PROJECT_SCOPING, projScoping})
  }
}

export const updateProjectScope = (projScoping) => {
  return (dispatch) => {
    dispatch({type: SET_PROJECT_SCOPING, projScoping});
    dispatch(computeTotals());
  }
}

export const computeTotals = () => {
  return (dispatch, getState) => {
    const scopes = getState().projects.projScoping;
    const projPlatforms = getState().projects.projPlatforms;

    let costingTotals = [];
    
    projPlatforms && projPlatforms.length && projPlatforms.forEach(platform => {
      let totalMandays = 0;
      let totalManhours = 0;
      let totalPercentage = 0;

      scopes.length && scopes.filter(data => {
        if (data.platform_id === platform.id) {
          return data;
        }
        return false;
      }).forEach(scope => {
        totalMandays += scope.mandays;
        totalManhours += scope.manhours;
        totalPercentage += scope.percentage;
      })

      totalPercentage = roundOffPercentage(parseFloat(totalPercentage.toFixed(2)));

      costingTotals.push(
        {totalMandays, totalManhours, totalPercentage, platformId: platform.id}
      )
    })

    dispatch({type: SET_COSTING_TOTALS, costingTotals});
  }
}

export const resetCostingTotals = () => {
  return (dispatch) => {
    dispatch({type: RESET_COSTING_TOTALS});
  }
}

export const saveProjectCosting = (projectId = null, showMessage = true) => {
  return (dispatch, getState) => {
    const projScopes = getState().projects.projScoping;
    let project = getState().projects.project;
    if (!projectId) {
      projectId = project.id;
    }

    Cache.setItem('numScopes', 0);

    let endpoint = '';
    
    projScopes.length && projScopes.forEach(scope => {
      let params = {
        project_id: projectId, 
        platform_id: scope.platform_id, 
        band_group: scope.band_group, 
        mandays: scope.mandays, 
        manhours: scope.manhours,
        percentage: scope.percentage 
      }

      if (typeof(scope.id) !== "undefined") {
        Object.assign(params, {id: scope.id});
        endpoint = 'project-scoping/update';
      } 
      else {
        endpoint = 'project-scoping/create';
      }
      client().post(
        endpoint, params 
      ).then(json => {
        const result = json.data;
        if (result) {
          let numScopes = Cache.getItem('numScopes');
          numScopes++;
          Cache.setItem('numScopes', numScopes);
          if (numScopes === projScopes.length) {
            Cache.removeItem('numScopes');
            dispatch(saveTaskDistribution(projectId, showMessage));
          }
        }
      }).catch(error => {
        dispatch(displayError(error));
      })
    })
  }
}

export const saveTaskDistribution = (projectId = null, showMessage = true) => {

  return (dispatch, getState) => {
    let projPlatformBands = getState().projects.projPlatformBands;

    if (!projectId) {
      const project = getState().projects.project;
      projectId = project.id;
    }

    Cache.setItem('numBands', 0);

    let bandsData = [];
    projPlatformBands = projPlatformBands && projPlatformBands.length && projPlatformBands.filter(data => {
      if (typeof(data.taskDistribution) !== "undefined") {
        return data;
      }
      return false;
    }).map(projPlatformBand => {
      return projPlatformBand;
    })

    if (projPlatformBands && projPlatformBands.length) {
      //construct the cost details 

      projPlatformBands.forEach(projPlatformBand => {
        const platformId = projPlatformBand.platform_id;
        bandsData.push(
          {
            platform_id: platformId, 
            platform_band_id: projPlatformBand.id, 
            task_distribution: projPlatformBand.taskDistribution, 
            project_estimate_hours: projPlatformBand.totalBandManHours, 
            project_cost: projPlatformBand.totalCostPerBand 
          }
        )
      })

      client().post(
        'project-costing/upsert', {
          project_id: projectId, 
          costing_details: bandsData
        }
      ).then(json => {
        const result = json.data;
        if (result) {
          let numBands = Cache.getItem('numBands');
          numBands++;
          Cache.setItem('numBands', numBands);
          if (numBands === projPlatformBands.length && showMessage) {
            dispatch(toggleShowAlert(true, SUCCESS_ALERT, "Project Costing has been successfully sent to approvers."));
          }
        }
      }).catch(error => {
        dispatch(displayError(error))
      })
    }
  }
}

//fetching of task distributions
export const fetchProjectCostings = (filters = null) => {
  let params = {}

  return (dispatch) => {
    if (filters && Object.keys(filters).length) {
      Object.assign(params, {filters})
    }

    client().get(
      'project-costing/list', {
        params, 
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      }
    ).then(json => {
      const result = json.data;
      if (result) {
        const taskDistributions = result.data;
        dispatch({type: SET_TASK_DISTRIBUTIONS, taskDistributions});
      }
    }).catch(error => {
      dispatch(displayError(error));
    })
  }
}

export const resetTaskDistributions = () => {
  return (dispatch) => {
    dispatch({type: RESET_TASK_DISTRIBUTION});
  }
}

export const combineTaskDistributionAndBands = (platformId) => {
  return (dispatch, getState) => {
    let platformBands = getState().projects.projPlatformBands;
    let taskDistributions = getState().projects.taskDistributions;
    let costingTotals = getState().projects.costingTotals;

    if (platformBands) {
      platformBands = platformBands.map(platformBand => {
        let taskDistribution = 0;
        let totalCostPerBand = 0;
        let totalBandManHours = 0;
        let totalManhours = 0;

        if (platformBand.platform_id === platformId) {
          taskDistributions.filter(data => {
            //TODO: platform_band_details should be object instead of array
            if ((data.platform_band_details[0].band_id === platformBand.band_id 
              || data.platform_band_id === platformBand.id) 
              && (data.platform_id === platformBand.platform_id)) {

              return data;
            }
            return false;
          }).forEach(_taskDistribution => {
            taskDistribution = _taskDistribution.task_distribution;
                      
            costingTotals.length && costingTotals.forEach(costingTotal => {
              if (costingTotal.platformId === platformBand.platform_id) {
                totalManhours = costingTotal.totalManhours;
              }
            })

            totalBandManHours = (taskDistribution / 100) * totalManhours;
            totalBandManHours = roundOffManHours(parseFloat(totalBandManHours.toFixed(2)));
            totalCostPerBand = totalBandManHours * platformBand.cost;
            
            totalBandManHours = _taskDistribution.project_estimate_hours;
          })

          platformBand.taskDistribution = taskDistribution;
          platformBand.totalCostPerBand = totalCostPerBand;
          platformBand.totalBandManHours = totalBandManHours;
        }
  
        return platformBand;
      })
    }

    dispatch({type: SET_PROJECT_PLATFORMS_BANDS, projPlatformBands: platformBands});
    dispatch(computeBlendedRate(platformId));
  }
}

export const updatePlatformBand = (bandId, taskDistribution, totalBandManHours, totalCostPerBand) => {
  return (dispatch) => {
    dispatch({type: UPDATE_PROJECT_PLATFORM_BAND, bandId, taskDistribution, totalBandManHours, totalCostPerBand})
  }
}

export const computeBlendedRate = (platformId, isEntering = false) => {
  return (dispatch, getState) => {
    const bands = getState().projects.projPlatformBands;
    let blendedRates = getState().projects.blendedRates;
    let costingTotals = getState().projects.costingTotals;

    let blendedRate = 0;
    let projEstimate = 0;
    let taskDistributions = 0;
    let fullyLoadedCost = 0;
    let mandays = 0;

    bands && bands.filter(data => {
      if (data.platform_id === platformId) {
        return data;
      }
      return false;
    }).forEach(band => {
      let taskDistribution = 0;
      if (typeof(band.totalCostPerBand) !== "undefined") {
        blendedRate += band.totalCostPerBand;
      }

      if (typeof(band.totalBandManHours) !== "undefined") {
        projEstimate += band.totalBandManHours;
      }

      if (typeof(band.taskDistribution) !== "undefined") {
        taskDistribution = band.taskDistribution;
        taskDistributions += taskDistribution;
      }
      
      fullyLoadedCost += taskDistribution * band.cost;
    })

    taskDistributions = roundOffPercentage(parseFloat(taskDistributions.toFixed(2)));

    //get mahhours
    costingTotals.length && costingTotals.filter(data => {
      if (data.platformId === platformId) {
        return data;
      }
      return false;
    }).forEach(costingTotal => {
      mandays = costingTotal.totalMandays;
    })

    let platformsWithRate = [];
    blendedRates.length && blendedRates.forEach(blendedRate => {
      platformsWithRate.push(blendedRate.platformId);
    })

    //if platform already has rates, modify. Else, add.
    if (platformsWithRate.includes(platformId)) {
      blendedRates = blendedRates.map(_blendedRate => {
        if (_blendedRate.platformId === platformId) {
          _blendedRate.blendedRate = blendedRate;
          _blendedRate.taskDistributions = taskDistributions;
          _blendedRate.fullyLoadedCost = fullyLoadedCost;
          _blendedRate.projEstimate = projEstimate;
          _blendedRate.mandays = mandays;
        }

        return _blendedRate;
      })

      dispatch({type: SET_BLENDED_RATES, blendedRates});   
    } 
    else {
      let objBlendedRate = {
        platformId, 
        blendedRate, 
        projEstimate,
        fullyLoadedCost,  
        taskDistributions,
        mandays
      }

      dispatch({type: ADD_BLENDED_RATES, blendedRate: objBlendedRate});   
    }
    
    /**
     * let's give some time to retrieve entries before computing 
     * the fully loaded cost when displaying. If entering, no need to wait
     */
    if (isEntering) {
      dispatch(computeTCV());
    }
    else {
      setTimeout(() => {
        dispatch(computeTCV());
      }, 3000) 
    }
  }
}

export const resetBlendedRates = () => {
  return (dispatch) => {
    dispatch({type: RESET_BLENDED_RATES});
  }
}

//computing fully_loaded_cost 
export const computeTCV = () => {
  return (dispatch, getState) => {
    const blendedRates = getState().projects.blendedRates;
    const project = getState().projects.project;

    let totalFullyLoadedCost = 0;
    let totalManhours = 0;
    let totalMandays = 0;

    blendedRates.length && blendedRates.forEach(blendedRate => {
      totalFullyLoadedCost += blendedRate.blendedRate;
      totalManhours += blendedRate.projEstimate;
      totalMandays += blendedRate.mandays;
    });

    //to make sure that we have project
    if (typeof(project.id) !== "undefined" || typeof(project.project_name) !== "undefined") {

      let roundedManhours = Math.round(totalManhours);

      if (roundedManhours > totalManhours) {
        const difference = parseFloat((roundedManhours - totalManhours).toFixed(2));
        if (difference === 0.01) {
          totalManhours = roundedManhours;
        }
      }
      else {
        const difference = parseFloat((totalManhours - roundedManhours).toFixed(2));
        if (difference === 0.01) {
          totalManhours = roundedManhours;
        }
      }

      project.fully_loaded_cost = totalFullyLoadedCost;
      project.costing_budgeted_hours = totalManhours;
      project.mandays = totalMandays;
  
      dispatch({type: SET_PROJECT, project});
    }
  }
}

export const roundOffPercentage = (totalPercentage) => {
  if (totalPercentage === 99.99 || totalPercentage === 100.01) {
    totalPercentage = 100;
  }

  return totalPercentage;
}

export const roundOffManHours = (manHours) => {
  
  let roundedManhours = Math.round(manHours);

  if (roundedManhours > manHours) {
    const difference = parseFloat((roundedManhours - manHours).toFixed(2));
    if (difference === 0.01) {
      manHours = roundedManhours;
    }
  }
  else {
    const difference = parseFloat((manHours - roundedManhours).toFixed(2));
    if (difference === 0.01) {
      manHours = roundedManhours;
    }
  }

  return manHours;
}